/**
 * Переключение фавиконки: обычная (`public/favicon/`) или с индикатором непрочитанного (`public/favicon-unread/`).
 */
import { isUserActivelyViewingCurrentTab } from '@/utils/browserAttention';

type FaviconFolder = 'favicon' | 'favicon-unread';
type FaviconReasonState = {
  unread: boolean;
  attention: boolean;
};

const faviconReasonState: FaviconReasonState = {
  unread: false,
  attention: false,
};

let attentionResetListenersAttached = false;

function publicUrlBase(): string {
  return (typeof process !== 'undefined' && process.env.PUBLIC_URL ? process.env.PUBLIC_URL : '').replace(
    /\/$/,
    ''
  );
}

function iconHref(folder: FaviconFolder, file: string): string {
  const base = publicUrlBase();
  const path = `${folder}/${file}`;
  return base ? `${base}/${path}` : `/${path}`;
}

function applyEffectiveFavicon(): void {
  if (typeof document === 'undefined') return;
  const folder: FaviconFolder =
    faviconReasonState.unread || faviconReasonState.attention ? 'favicon-unread' : 'favicon';

  const set = (selector: string, file: string) => {
    const el = document.querySelector(selector) as HTMLLinkElement | null;
    if (el) el.href = iconHref(folder, file);
  };

  set('link[rel="icon"][type="image/svg+xml"]', 'favicon.svg');
  set('link[rel="icon"][type="image/png"][sizes="96x96"]', 'favicon-96x96.png');
  set('link[rel="shortcut icon"]', 'favicon.ico');
  set('link[rel="apple-touch-icon"]', 'apple-touch-icon.png');
}

function maybeResetAttentionFavicon(): void {
  if (!faviconReasonState.attention) return;
  if (!isUserActivelyViewingCurrentTab()) return;
  faviconReasonState.attention = false;
  applyEffectiveFavicon();
}

function ensureAttentionResetListeners(): void {
  if (typeof document === 'undefined' || attentionResetListenersAttached) return;
  attentionResetListenersAttached = true;
  document.addEventListener('visibilitychange', maybeResetAttentionFavicon, { passive: true });
  window.addEventListener('focus', maybeResetAttentionFavicon, { passive: true });
}

export function applyChatUnreadFavicon(unread: boolean): void {
  faviconReasonState.unread = unread;
  applyEffectiveFavicon();
}

export function markChatIncomingAttentionFavicon(): void {
  faviconReasonState.attention = true;
  ensureAttentionResetListeners();
  applyEffectiveFavicon();
}
